export default "__VITE_ASSET__2afd8bea__"